import { APP_MODULES } from './appModules';
import { WELL_GUARDIAN_MODULES } from './wellGuardianModules';

export const MODULE_ROOT_PATHS = {
  // HOME
  [APP_MODULES.HOME]: '/',
  // WELL GUARDIAN
  [APP_MODULES.WELL_GUARDIAN]: '/well-guardian',
} as const;

export const WELL_GUARDIAN_ROOT_PATHS = {
  HOME: `/`,
  [WELL_GUARDIAN_MODULES.WELL_HEALTH]: '/well-health',
  [WELL_GUARDIAN_MODULES.INTERVENTIONS]: '/interventions',
  [WELL_GUARDIAN_MODULES.DEROGATIONS]: '/derogations',
  [WELL_GUARDIAN_MODULES.SYNERGI_CASES]: '/synergi-cases',
  [WELL_GUARDIAN_MODULES.KEY_LINKS]: '/key-links',
  [WELL_GUARDIAN_MODULES.ALERTS_SUBSCRIPTION]: '/alerts-subscription',
} as const;

export const WELL_GUARDIAN_WELL_HEALTH_MODULE_ROOT_PATHS = {
  [WELL_GUARDIAN_MODULES.WELL_SINGLE_OVERVIEW]: '/overview',
  [WELL_GUARDIAN_MODULES.WELL_SINGLE_SCHEMATIC]: '/schematic',
  [WELL_GUARDIAN_MODULES.WELL_REVIEWS]: '/wellReviews',
  [WELL_GUARDIAN_MODULES.WELL_SINGLE_CHARTS]: '/charts',
  [WELL_GUARDIAN_MODULES.WELL_BEHAVIOUR]: '/behaviour',
  [WELL_GUARDIAN_MODULES.WELL_DGS_HSE]: '/integrityDetails',
  [WELL_GUARDIAN_MODULES.WELL_RESOURCE]: '/resources',
  [WELL_GUARDIAN_MODULES.WELL_ALERTS]: '/alerts',
} as const;

export const WELL_GUARDIAN_INTERVENTIONS_MODULE_ROOT_PATHS = {
  [WELL_GUARDIAN_MODULES.WIR_LIST]: '/wir-list',
  [WELL_GUARDIAN_MODULES.WIR_CREATION]: '/wir',
} as const;

export const WELL_GUARDIAN_PATHS = {
  HOME: `${MODULE_ROOT_PATHS.HOME}`,
  WELL_GUARDIAN: `${MODULE_ROOT_PATHS.WELL_GUARDIAN}`,
  WELL_GUARDIAN_WELL_HEALTH_HOME: `${MODULE_ROOT_PATHS.WELL_GUARDIAN}${WELL_GUARDIAN_ROOT_PATHS.WELL_HEALTH}`,
  WELL_GUARDIAN_WELL_SINGLE_OVERVIEW: `${MODULE_ROOT_PATHS.WELL_GUARDIAN}${WELL_GUARDIAN_ROOT_PATHS.WELL_HEALTH}/:tuwi${WELL_GUARDIAN_WELL_HEALTH_MODULE_ROOT_PATHS.WELL_SINGLE_OVERVIEW}`,
  WELL_GUARDIAN_WELL_SINGLE_SCHEMATIC: `${MODULE_ROOT_PATHS.WELL_GUARDIAN}${WELL_GUARDIAN_ROOT_PATHS.WELL_HEALTH}/:tuwi${WELL_GUARDIAN_WELL_HEALTH_MODULE_ROOT_PATHS.WELL_SINGLE_SCHEMATIC}`,
  WELL_GUARDIAN_WELL_WELL_REVIEWS: `${MODULE_ROOT_PATHS.WELL_GUARDIAN}${WELL_GUARDIAN_ROOT_PATHS.WELL_HEALTH}/:tuwi${WELL_GUARDIAN_WELL_HEALTH_MODULE_ROOT_PATHS.WELL_REVIEWS}`,
  WELL_GUARDIAN_WELL_SINGLE_CHARTS: `${MODULE_ROOT_PATHS.WELL_GUARDIAN}${WELL_GUARDIAN_ROOT_PATHS.WELL_HEALTH}/:tuwi${WELL_GUARDIAN_WELL_HEALTH_MODULE_ROOT_PATHS.WELL_SINGLE_CHARTS}`,
  WELL_GUARDIAN_WELL_BEHAVIOUR: `${MODULE_ROOT_PATHS.WELL_GUARDIAN}${WELL_GUARDIAN_ROOT_PATHS.WELL_HEALTH}/:tuwi${WELL_GUARDIAN_WELL_HEALTH_MODULE_ROOT_PATHS.WELL_BEHAVIOUR}`,
  WELL_GUARDIAN_INTEGRITY_DETAILS: `${MODULE_ROOT_PATHS.WELL_GUARDIAN}${WELL_GUARDIAN_ROOT_PATHS.WELL_HEALTH}/:tuwi${WELL_GUARDIAN_WELL_HEALTH_MODULE_ROOT_PATHS.WELL_DGS_HSE}`,
  WELL_GUARDIAN_WELL_RESOURCES: `${MODULE_ROOT_PATHS.WELL_GUARDIAN}${WELL_GUARDIAN_ROOT_PATHS.WELL_HEALTH}/:tuwi${WELL_GUARDIAN_WELL_HEALTH_MODULE_ROOT_PATHS.WELL_RESOURCE}`,
  WELL_GUARDIAN_SINGLE_WELL_ALERTS: `${MODULE_ROOT_PATHS.WELL_GUARDIAN}${WELL_GUARDIAN_ROOT_PATHS.WELL_HEALTH}/:tuwi${WELL_GUARDIAN_WELL_HEALTH_MODULE_ROOT_PATHS.WELL_ALERTS}`,
  WELL_GUARDIAN_ALERTS_SUBSCRIPTION: `${MODULE_ROOT_PATHS.WELL_GUARDIAN}${WELL_GUARDIAN_ROOT_PATHS.ALERTS_SUBSCRIPTION}`,
  WELL_GUARDIAN_MULTIPLE_WELLS_ALERTS: `${MODULE_ROOT_PATHS.WELL_GUARDIAN}${WELL_GUARDIAN_ROOT_PATHS.WELL_HEALTH}${WELL_GUARDIAN_WELL_HEALTH_MODULE_ROOT_PATHS.WELL_ALERTS}`,
  WELL_GUARDIAN_INTERVENTIONS: `${MODULE_ROOT_PATHS.WELL_GUARDIAN}${WELL_GUARDIAN_ROOT_PATHS.INTERVENTIONS}`,
  WELL_GUARDIAN_DEROGATIONS: `${MODULE_ROOT_PATHS.WELL_GUARDIAN}${WELL_GUARDIAN_ROOT_PATHS.DEROGATIONS}`,
  WELL_GUARDIAN_SYNERGI_CASES: `${MODULE_ROOT_PATHS.WELL_GUARDIAN}${WELL_GUARDIAN_ROOT_PATHS.SYNERGI_CASES}`,
  WELL_GUARDIAN_KEY_LINK: `${MODULE_ROOT_PATHS.WELL_GUARDIAN}${WELL_GUARDIAN_ROOT_PATHS.KEY_LINKS}`,
  WELL_GUARDIAN_WIR_CREATION: `${MODULE_ROOT_PATHS.WELL_GUARDIAN}${WELL_GUARDIAN_ROOT_PATHS.INTERVENTIONS}/:country${WELL_GUARDIAN_INTERVENTIONS_MODULE_ROOT_PATHS.WIR_CREATION}/:wirId`,
};

export const PATHS = {
  ...WELL_GUARDIAN_PATHS,
};

export type PATH = (typeof PATHS)[keyof typeof PATHS];
